import React, { useEffect, useRef } from "react";
import Particles from "./Particles";
import "./Hero.css";

export default function Hero({ data }) {
  const titleRef = useRef(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    setTimeout(() => el.classList.add("hero__title--visible"), 100);
  }, []);

  return (
    <section id="hero" className="hero section">
      <Particles />
      <div className="hero__bg" />
      <div className="hero__grid" />

      <div className="hero__content">
        <span className="hero__tag">
          <span className="hero__tag-dot" />
          {data.role} · MERN Stack
        </span>

        <h1 className="hero__title" ref={titleRef}>
          <span className="hero__title-solid">{data.name.split(" ")[0]}</span>
          <br />
          <span className="hero__title-outline">{data.name.split(" ")[1]}</span>
        </h1>

        <p className="hero__sub">{data.tagline}</p>

        <div className="hero__cta">
          <a href="#projects" className="btn btn--primary">View Projects</a>
          <a href="#contact" className="btn btn--outline">Get in Touch</a>
        </div>
      </div>

      <div className="hero__scroll">
        <span className="hero__scroll-line" />
        <span className="hero__scroll-label">scroll</span>
      </div>

      {/* floating decoration */}
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />
    </section>
  );
}
